import { render, staticRenderFns } from "./buy3sClone.vue?vue&type=template&id=31e75fa6&scoped=true&"
import script from "./buy3sClone.vue?vue&type=script&lang=js&"
export * from "./buy3sClone.vue?vue&type=script&lang=js&"
import style0 from "./buy3sClone.vue?vue&type=style&index=0&id=31e75fa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e75fa6",
  null
  
)

export default component.exports